// import {Rule} from 'antd/lib/form'
// import dayjs from 'dayjs'

type VariationTermType = 'same' | 'extend'
type VariationLoanType = 'same' | 'reduce' | 'increase'
type VariationTermFullnameType = `${VariationTermType} term`
type VariationLoanFullnameType = `${VariationLoanType} loan amount`
type VariationTypeAll   = `${VariationTermFullnameType}, ${VariationLoanFullnameType}`
type VariationType = Capitalize<Exclude<VariationTypeAll, 'same term, same loan amount'>>

type VariationTypeOption = {
  value: VariationType, label: VariationType
}

export const VARIATION_TYPE_OPTIONS: VariationTypeOption[] = [
  { value: 'Same term, reduce loan amount',     label: 'Same term, reduce loan amount'},
  { value: 'Same term, increase loan amount',   label: 'Same term, increase loan amount'},
  { value: 'Extend term, same loan amount',     label: 'Extend term, same loan amount'},
  { value: 'Extend term, reduce loan amount',   label: 'Extend term, reduce loan amount'},
  { value: 'Extend term, increase loan amount', label: 'Extend term, increase loan amount'},
]

export const isSameTerm: (t:string) => boolean = (type) => (
  (!!type) && 
  (type.toString().toLocaleLowerCase().indexOf(
    'same term'
  ) > -1) 
)
export const isSameAmount: (t:string) => boolean = (type) => (
  (!!type) && 
  (type.toString().toLocaleLowerCase().indexOf(
    'same loan amount'
  ) > -1)
)
export const isReduceAmount: (t:string) => boolean = (type) => (
  (!!type) && 
  (type.toString().toLocaleLowerCase().indexOf(
    'reduce loan amount'
  ) > -1)
)
export const isIncreaseAmount: (t:string) => boolean = (type) => (
  (!!type) && 
  (type.toString().toLocaleLowerCase().indexOf(
    'increase loan amount'
  ) > -1)
)
export const isExtendTerm: (t:string) => boolean = (type) => (
  (!!type) && 
  (type.toString().toLocaleLowerCase().indexOf(
    'extend term'
  ) > -1) 
)